// extracted by mini-css-extract-plugin
export default {"mainWrapper":"AddEditBrandModal_mainWrapper__1S987","buttonsContainer":"AddEditBrandModal_buttonsContainer__6uxXW"};